__turbopack_context__.v({
  "className": "_72KYEq_className",
});
